<template>
    <div class="form-component"
         :class="assignClasses">
        <select :name="name"
                :id="id"
                class="select-field"
                :is_required="required"
                v-model="innerValue">
            <option v-for="(option, index) in options"
                    :key="`${name}${index}`"
                    :value="option.value"
                    :disabled="option.disabled"
            >{{option.text}}</option>
        </select>
        <label class="form-label"
               :for="id">
            <slot></slot><span v-if="required" class="asterix">*</span>
        </label>
        <span class="select-arrow"></span>
        <span class="form-error font-bebas-neue">{{error}}</span>
    </div>
</template>

<script>
    export default {
        name: "SelectField",
        props: {
            name: String,
            type: {
                type: String,
                default: 'text'
            },
            error: {
                type: String,
                default: ''
            },
            color: {
                type: String,
                default: ''
            },
            id: String,
            options: {
                type: Array,
                default: new Array()
            },
            value: [String, Number],
            required: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            isValid() {
                let result = false;
                if(this.internalValidator(this.value)){
                    result = true;
                }
                return result;
            },
            assignClasses() {
                let resultClasses = '';
                if (this.isValid) {
                    resultClasses += 'form-has-value ';
                }
                if (this.error.length) {
                    resultClasses += 'color-error';
                } else {
                    switch (this.color) {
                        case 'primary':
                            resultClasses += 'color-primary';
                            break;
                        case 'secondary':
                            resultClasses += 'color-secondary';
                            break;
                        case 'error':
                            resultClasses += 'color-error';
                            break;
                        default:
                            break;
                    }
                }
                return resultClasses;
            },
        },
        data() {
            return {
                innerValue: ''
            }
        },
        mounted() {
            this.innerValue = this.value;
            this.$emit('validation-result', {'name': this.name, 'valid': this.internalValidator(this.value)});
        },
        watch: {
            innerValue(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.$emit('input', newVal);
                    this.$emit('validation-result', {'name': this.name, 'valid': this.internalValidator(newVal)});
                }
            },
            value(newVal) {
                this.innerValue = newVal;
            }
        },
        methods: {
            internalValidator(value) {
                let result = false;
                if(!this.required && !value){
                    result = true;
                }else{

                    let selected = this.options.find(obj => {
                        return obj.value === value
                    });
                    //if(selected !== undefined && selected.text.toString().length) {
                    if (selected) {
                        result = true;
                    }
                }
                return result;
            },
            updateValue(value) {
                this.$emit('input', value)
            },
        },
    }
</script>

<style scoped>
    .asterix {
        color: var(--color-error);
    }

    .form-component {
        min-height: 50px;
        position: relative;
        padding-top: 14px;

        /*border: 1px solid red;*/
    }

    .select-field {
        width: 100%;
        border: 0px solid var(--color-grey);
        border-bottom-width: 1px;
        border-radius: 0;
        background: transparent;
        font-size: 14px;
        color: var(--color-dark);
        appearance: none;
        /* transition: all 0.25s ease-in-out; */
        z-index: 25;
        position: relative;
    }

    .select-arrow {
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 8px solid var(--color-grey);
        border-bottom: 0px solid transparent;
        width: 0;
        height: 0;
        display: block;
        position: absolute;
        top: 20px;
        right: 3px;
        z-index: 20;
        /* transition: all 0.25s ease-in-out; */
    }

    .select-field:focus {
        box-shadow: none;
        outline: none;
        color: var(--color-dark);
        border-bottom-color: var(--color-dark);
    }

    .select-field:focus ~ .select-arrow {
        border-top: 8px solid var(--color-dark);
    }

    .form-label {
        position: absolute;
        top: 15px;
        left: 0;
        width: 100%;
        color: var(--color-dark);
        /* transition: all 0.25s ease-in-out; */
        text-transform: uppercase;
        font-size: 12px;
        cursor: text;
        pointer-events: none;
    }

    .color-error > .form-label,
    .form-has-value > .form-label {
        top: 0;
        font-size: 10px;
    }

    .form-field:focus ~ .form-label {
        top: 0;
        font-size: 10px;
    }

    .form-error {
        opacity: 0;
        font-size: 12px;
        text-transform: uppercase;
        color: var(--color-error);
        /* transition: all 0.25s ease-in-out; */
    }

    .color-error > .select-field:focus ~ .form-label,
    .color-error > .form-label,
    .color-error > .select-field,
    .color-error > .form-error {
        color: var(--color-error);
    }

    .color-error > .select-field {
        border-bottom-color: var(--color-error);
    }

    .color-error > .form-error {
        opacity: 1;
    }

    .color-error > .select-field:focus ~ .form-error,
    .color-error > .select-field:focus ~ .form-label {
        color: var(--color-error-dark);
    }

    .color-error > .select-field:focus {
        color: var(--color-error-dark);
        border-bottom-color: var(--color-error-dark);
    }

    .color-primary > .select-field:focus ~ .form-label,
    .color-primary > .form-label,
    .color-primary > .select-field,
    .color-primary > .form-error {
        color: var(--color-primary);
    }

    .color-primary > .select-field {
        border-bottom-color: var(--color-primary);
    }

    .color-primary > .select-field:focus ~ .form-label {
        color: var(--color-primary-dark);
    }

    .color-primary > .select-field:focus {
        color: var(--color-primary-dark);
        border-bottom-color: var(--color-primary-dark);
    }

    .color-secondary > .select-field:focus ~ .form-label,
    .color-secondary > .form-label,
    .color-secondary > .select-field,
    .color-secondary > .form-error {
        color: var(--color-secondary);
    }

    .color-secondary > .select-field {
        border-bottom-color: var(--color-secondary);
    }

    .color-secondary > .select-field:focus ~ .form-label {
        color: var(--color-secondary-dark);
    }

    .color-secondary > .select-field:focus {
        color: var(--color-secondary-dark);
        border-bottom-color: var(--color-secondary-dark);
    }
</style>
